import Reflux from 'reflux';
/*
	ChoiceActionsFactory

	Creates Reflux Choice Actions for each Question.
	Prevents choices from multiple Questions from listening and triggering the same actions.
*/
class ChoiceActionsFactory{
	constructor(){
		this.actions = {};
	}
	get(questionId){
		const key = `question-${questionId}`;
		if(!this.actions[key]){
			this.actions[key] = Reflux.createActions([
				'change'
			]);
		}
		return this.actions[key];

	}
}

export default new ChoiceActionsFactory();


// WEBPACK FOOTER //
// ./medscape_modules/qna/form-components/choices/choice-actions-factory.js